const routes = {
    path: 'usuarios',
    name: 'Usuarios',
    component: () => import('./Listagem.vue'),
    meta: {
        rules: ['CTRLACS-USR-00'],
    },
    children: [
        {
            path: ':id',
            name: 'Usuarios_Detalhar',
            component: () => import('./Detalhar.vue'),
            meta: {
                rules: ['CTRLACS-USR-02'],
            },
        },
        {
            path: 'inserir',
            name: 'Usuarios_Inserir',
            component: () => import('./Inserir.vue'),
            meta: {
                rules: ['CTRLACS-USR-01'],
            },
        },
        {
            path: ':id/atualizar',
            name: 'Usuarios_Atualizar',
            component: () => import('./Atualizar.vue'),
            meta: {
                rules: ['CTRLACS-USR-03'],
            },
        },
    ],
};

export default routes;
